
import {
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESSPLAN,
  ASYNC_FETCH_FAILURE,
  SET_SELECTED_REMARK,
  SET_ISREMARKS_LOAD,
  SET_ISREDIRECT_TO_HUB
  
} from '../constants';

import { updateObject } from '../../../shared/utilities/reducer';
import common from '../../../shared/utilities/common';

const initialState = {
  isFetching: true,
  statusCode: "",
  statusMessage: "",
  errorMessage: '',
  errorDesc: '',
  actionName: '',
  actionValue: '',
  errorObj: {},
  pageData: "",
  isUpdatingGenerateRemarks: true,
  selectedRemarks: {},
  emailObj: [],
  isRedirectToHub:false

}


export const asyncFetch_ILD = (state, action) => {
  console.log("getSectionsBegin called")
  return updateObject(state, {
    isFetching: true
  });
};

export const asyncFetchSuccess_ILD = (state, action) => {

  console.log("getSectionSuccess called")
  let responseCode = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseCode;
  let responseMessage = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseMessage;
  let responseBody = action.msResp && action.msResp.body;

  return updateObject(state, {
    isFetching: false,
    statusCode: responseCode,
    statusMessage: responseMessage,
    errorMessage: common.isError(responseCode, responseMessage, responseBody),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, responseBody),
    actionName: common.isActionName(responseCode, responseMessage, responseBody),
    actionValue: common.isActionValue(responseCode, responseMessage, responseBody),
    errorObj: responseCode !== "00" && action.msResp && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
    pageData: responseBody
  });
};

export const asyncFetchFailed_ILD = (state, action) => {

  //Dont Delete this code untill implementing code to handel 500 status code error
  let msResp = action && action.err && action.err.response && action.err.response.data;
  let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
  let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
  let body = msResp && msResp.body;
  return updateObject(state, {
    isFetching: false,
    pageData: {},
    statusCode: responseCode ? responseCode : '',
    errorMessage: common.isError(responseCode, responseMessage, body),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
    actionName: common.isActionName(responseCode, responseMessage, body),
    actionValue: common.isActionValue(responseCode, responseMessage, body),
    errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
  });
};



export const setSelectedRemarkValue_ILD = (state, action) => {
  return updateObject(state, {
    selectedRemarks: action.data
  });
};

export const setisRemarksValue = (state, action) => {

  return updateObject(state, {
    isRemarksLoad: action.data
  });
};

export const setRedirectToHub = (state, action) => {
  return updateObject(state, {
    isRedirectToHub: action.data
  });
};


export const ILDRemarksReducer = (state = initialState, action) => {

  const { type } = action;
  switch (type) {
    case ASYNC_FETCH:
      return asyncFetch_ILD(state, action);
    case ASYNC_FETCH_SUCCESSPLAN:
      return asyncFetchSuccess_ILD(state, action);
    case ASYNC_FETCH_FAILURE:
      return asyncFetchFailed_ILD(state, action);
    case SET_SELECTED_REMARK:
      return setSelectedRemarkValue_ILD(state, action);
    case SET_ISREMARKS_LOAD:
      return setisRemarksValue(state, action);
      case SET_ISREDIRECT_TO_HUB:
      return setRedirectToHub(state, action);
    default:
      return state;
  }
};

